var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdoptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear_688_12315)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_688_12315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 11C18.22 11 16.4799 11.5278 14.9999 12.5168C13.5198 13.5057 12.3663 14.9113 11.6851 16.5558C11.0039 18.2004 10.8257 20.01 11.1729 21.7558C11.5202 23.5016 12.3774 25.1053 13.636 26.364C14.8947 27.6226 16.4984 28.4798 18.2442 28.8271C19.99 29.1743 21.7996 28.9961 23.4442 28.3149C25.0887 27.6337 26.4943 26.4802 27.4832 25.0001C28.4722 23.5201 29 21.78 29 20C28.9974 17.6138 28.0484 15.3262 26.3611 13.6389C24.6738 11.9516 22.3862 11.0026 20 11ZM20 27.5C18.5166 27.5 17.0666 27.0601 15.8332 26.236C14.5999 25.4119 13.6386 24.2406 13.0709 22.8701C12.5033 21.4997 12.3547 19.9917 12.6441 18.5368C12.9335 17.082 13.6478 15.7456 14.6967 14.6967C15.7456 13.6478 17.082 12.9335 18.5368 12.6441C19.9917 12.3547 21.4997 12.5032 22.8701 13.0709C24.2406 13.6386 25.4119 14.5999 26.236 15.8332C27.0601 17.0666 27.5 18.5166 27.5 20C27.4978 21.9885 26.7069 23.8948 25.3009 25.3009C23.8948 26.7069 21.9885 27.4978 20 27.5ZM20.75 19.25H23.75V20.75H20.75V23.75H19.25V20.75H16.25V19.25H19.25V16.25H20.75V19.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_688_12315",
    x1: 0,
    y1: 0,
    x2: 40,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63F3F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_688_12315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdoptionIcon);
export default __webpack_public_path__ + "static/media/adoption-icon.352fd9a7bd8889339190e774c2d67cbe.svg";
export { ForwardRef as ReactComponent };